(() => {
  const key = 'orlevanto-currency-choice';
  const currencyToCountry = { EUR: 'BE', GBP: 'GB', USD: 'US' };
  const read = () => { try { return localStorage.getItem(key); } catch { return null; } };
  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-orlevanto-currency]');
    if (!select) return;
    try { localStorage.setItem(key, select.value); sessionStorage.removeItem('orlevanto-currency-attempt'); } catch {}
    select.form.requestSubmit();
  });
  const form = document.querySelector('[data-orlevanto-currency-form]');
  if (!form || document.documentElement.classList.contains('shopify-design-mode')) return;
  const stored = read();
  const preferred = currencyToCountry[stored] || stored;
  const select = form.querySelector('[data-orlevanto-currency]');
  if (!select || !preferred || !Array.from(select.options).some(option => option.value === preferred) || select.value === preferred) return;
  try {
    if (sessionStorage.getItem('orlevanto-currency-attempt') === preferred) return;
    sessionStorage.setItem('orlevanto-currency-attempt', preferred);
  } catch { return; }
  select.value = preferred;
  form.requestSubmit();
})();